/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LANGUAGE = "DANISH" | "ENGLISH_EU" | "ENGLISH_UK" | "ENGLISH_US" | "FRENCH" | "POLISH" | "SPANISH" | "%future added value";
export type UpdateClientPersonInput = {
    id: string;
    email?: string | null | undefined;
    clientId: string;
    invited?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateClientPersonMutationVariables = {
    input: UpdateClientPersonInput;
};
export type updateClientPersonMutationResponse = {
    readonly updateClientPerson: {
        readonly errors: ReadonlyArray<string | null> | null;
        readonly person: {
            readonly email: string | null;
            readonly jobTitle: string | null;
            readonly department: {
                readonly id: string;
            } | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly initials: string | null;
            readonly profiles: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                } | null> | null;
            } | null;
            readonly permissions: ReadonlyArray<string | null> | null;
            readonly cost: number | null;
            readonly phone: string | null;
            readonly language: LANGUAGE | null;
            readonly active: boolean | null;
            readonly invited: boolean | null;
            readonly profilePictureId: string | null;
            readonly excludeFromCompanyLockedPeriod: boolean | null;
            readonly startDate: string | null;
            readonly endDate: string | null;
            readonly role: {
                readonly id: string;
                readonly name: string | null;
            } | null;
            readonly holidayCalendar: {
                readonly id: string;
            } | null;
            readonly personLabels: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly label: {
                            readonly id: string;
                        } | null;
                    } | null;
                } | null> | null;
            } | null;
            readonly gitlabUser: {
                readonly integrationUserId: number | null;
            } | null;
            readonly gitlabServerUser: {
                readonly integrationUserId: number | null;
            } | null;
            readonly githubUser: {
                readonly integrationUserId: number | null;
            } | null;
            readonly unit4UserObject: string | null;
            readonly jiraCloudId: string | null;
            readonly jiraServerId: string | null;
        } | null;
        readonly viewer: {
            readonly permissions: ReadonlyArray<string | null> | null;
            readonly profiles: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly permissions: ReadonlyArray<string | null> | null;
                    } | null;
                } | null> | null;
            } | null;
            readonly company: {
                readonly userSeats: number | null;
                readonly virtualSeats: number | null;
            } | null;
        } | null;
    } | null;
};
export type updateClientPersonMutation = {
    readonly response: updateClientPersonMutationResponse;
    readonly variables: updateClientPersonMutationVariables;
};



/*
mutation updateClientPersonMutation(
  $input: UpdateClientPersonInput!
) {
  updateClientPerson(input: $input) {
    errors
    person {
      email
      jobTitle
      department {
        id
      }
      firstName
      lastName
      initials
      profiles(first: 10000) {
        edges {
          node {
            id
            name
          }
        }
      }
      permissions
      cost
      phone
      language
      active
      invited
      profilePictureId
      excludeFromCompanyLockedPeriod
      startDate
      endDate
      role {
        id
        name
      }
      holidayCalendar {
        id
      }
      personLabels(first: 10000) {
        edges {
          node {
            label {
              id
            }
            id
          }
        }
      }
      gitlabUser {
        integrationUserId
      }
      gitlabServerUser {
        integrationUserId
      }
      githubUser {
        integrationUserId
      }
      unit4UserObject
      jiraCloudId
      jiraServerId
      id
    }
    viewer {
      permissions
      profiles(first: 10000) {
        edges {
          node {
            id
            name
            permissions
          }
        }
      }
      company {
        userSeats
        virtualSeats
        id
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateClientPersonInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobTitle",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "DepartmentType",
  "kind": "LinkedField",
  "name": "department",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initials",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  (v5/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "ProfileTypeConnection",
  "kind": "LinkedField",
  "name": "profiles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v13/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "profiles(first:10000)"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invited",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "excludeFromCompanyLockedPeriod",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "HolidayCalendar",
  "kind": "LinkedField",
  "name": "holidayCalendar",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v28 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "integrationUserId",
    "storageKey": null
  }
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "gitlabUser",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "gitlabServerUser",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "githubUser",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4UserObject",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCloudId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerId",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": (v11/*: any*/),
  "concreteType": "ProfileTypeConnection",
  "kind": "LinkedField",
  "name": "profiles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v12/*: any*/),
            (v15/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "profiles(first:10000)"
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userSeats",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "virtualSeats",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateClientPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateClientPersonPayload",
        "kind": "LinkedField",
        "name": "updateClientPerson",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "PersonLabelTypeConnection",
                "kind": "LinkedField",
                "name": "personLabels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonLabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "personLabels(first:10000)"
              },
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v36/*: any*/),
                  (v37/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateClientPersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateClientPersonPayload",
        "kind": "LinkedField",
        "name": "updateClientPerson",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "PersonLabelTypeConnection",
                "kind": "LinkedField",
                "name": "personLabels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonLabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "personLabels(first:10000)"
              },
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v35/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateClientPersonMutation",
    "operationKind": "mutation",
    "text": "mutation updateClientPersonMutation(\n  $input: UpdateClientPersonInput!\n) {\n  updateClientPerson(input: $input) {\n    errors\n    person {\n      email\n      jobTitle\n      department {\n        id\n      }\n      firstName\n      lastName\n      initials\n      profiles(first: 10000) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      permissions\n      cost\n      phone\n      language\n      active\n      invited\n      profilePictureId\n      excludeFromCompanyLockedPeriod\n      startDate\n      endDate\n      role {\n        id\n        name\n      }\n      holidayCalendar {\n        id\n      }\n      personLabels(first: 10000) {\n        edges {\n          node {\n            label {\n              id\n            }\n            id\n          }\n        }\n      }\n      gitlabUser {\n        integrationUserId\n      }\n      gitlabServerUser {\n        integrationUserId\n      }\n      githubUser {\n        integrationUserId\n      }\n      unit4UserObject\n      jiraCloudId\n      jiraServerId\n      id\n    }\n    viewer {\n      permissions\n      profiles(first: 10000) {\n        edges {\n          node {\n            id\n            name\n            permissions\n          }\n        }\n      }\n      company {\n        userSeats\n        virtualSeats\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0d06ffc79c2019acf5ccacd1110386f2';
export default node;
